import * as React from 'react';
import { BooleanField, Datagrid, DateField, List, TextField } from 'react-admin';
import { CustomTitle } from '../../components/CustomTitle';
import { IndexField } from '../../components/IndexField';

export const NotificationsList = (props: unknown) => (
  <List sort={{ field: 'title', order: 'ASC' }} title={<CustomTitle />} {...props}>
    <Datagrid rowClick="edit">
      <IndexField label="#" sortable={false} />
      <TextField source="id" />
      <TextField source="title" />
      <TextField source="message" />
      <DateField source="deliveryDate" showTime />
      <BooleanField source="delivered" />
    </Datagrid>
  </List>
);
